import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/services';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { UserRoleType } from '../../../shared/helpers/app.constants';

@Injectable()
export class ManageUsersService {
  private prefixPath = '/companies/users';

  constructor(private apiService: ApiService) { }

  // Navigate api calls by user role
  getUsers(role: string, companyId?: any): Observable<any> {
    if (role === UserRoleType.carboAdmin) {
      return this.getUsersByCompanyCarboAdmin(companyId);
    } else {
      return this.getUserClientAdmin();
    }
  }

  async getUserDetail(role: string, id = '') {
    try {
      let response;
      if (role === UserRoleType.carboAdmin) {
        response = await this.getUserDetailCarboAdmin(id).toPromise();
      } else {
        response = await this.getUserDetailClientAdmin(id).toPromise();
      }
      if (response && response.result) {
        return response.result;
      }
      return;
    } catch (err) {
      throw err;
    }
  }

  addUser(role: string, param: any, finalize?: VoidFunction) {
    if (role === UserRoleType.carboAdmin) {
      return this.addUserCarboAdmin(param, finalize);
    } else {
      return this.addUserClientAdmin(param, finalize);
    }
  }

  updateUser(role: string, id = '', param: any, finalize?: VoidFunction) {
    if (role === UserRoleType.carboAdmin) {
      return this.updateUserCarboAdmin(id, param, finalize);
    } else {
      return this.updateUserClientAdmin(id, param, finalize);
    }
  }

  deleteUser(role: string, id = '', finalize?: VoidFunction) {
    if (role === UserRoleType.carboAdmin) {
      return this.deleteUserCarboAdmin(id, finalize);
    } else {
      return this.deleteUserClientAdmin(id, finalize);
    }
  }

  // Api calls for Carbo Admin
  getUsersByCompanyCarboAdmin(companyId?: any): Observable<any> {
    const path = `${this.prefixPath}`;
    let params = new HttpParams();
    if (companyId) {
      params = params.set('tenantId', companyId);
      return this.apiService.get(`${path}`, params);
    } else {
      return this.apiService.get(path);
    }
  }

  getUserDetailCarboAdmin(id = '') {
    return this.apiService.get(`${this.prefixPath}/${id}`);
  }

  addUserCarboAdmin(param: any, finalize?: VoidFunction) {
    return this.apiService.post(`${this.prefixPath}`, param, finalize);
  }

  updateUserCarboAdmin(id = '', param: any, finalize?: VoidFunction) {
    return this.apiService.put(`${this.prefixPath}/${id}`, param, finalize);
  }

  deleteUserCarboAdmin(id = '', finalize?: VoidFunction) {
    return this.apiService.delete(`${this.prefixPath}/${id}`, finalize);
  }

  // Api calls for Client Admin
  getUserClientAdmin(param?: any) {
    return this.apiService.get(`${this.prefixPath}`, param);
  }

  addUserClientAdmin(param: any, finalize?: VoidFunction) {
    return this.apiService.post(`${this.prefixPath}/`, param, finalize);
  }

  updateUserClientAdmin(id = '', param: any, finalize?: VoidFunction) {
    return this.apiService.put(`${this.prefixPath}/${id}`, param, finalize);
  }

  deleteUserClientAdmin(id = '', finalize?: VoidFunction) {
    return this.apiService.delete(`${this.prefixPath}/${id}`, finalize);
  }

  getUserDetailClientAdmin(id) {
    let params = new HttpParams();
    if (id) {
      params = params.set('Id', id);
    }
    return this.apiService.get(`${this.prefixPath}/${id}`);
  }
}
